<template>
  <div>
    <eepos-header
      v-if="$route.name != 'registration' && user"
      :username="userName()"
      :locale="$i18n.locale"
      :testing="isTestingSystem"
      :token="token"
      @logout-click="logout"
    >
      <router-link to="/">User management</router-link>
      <div slot="subheader">
        <router-view name="header" />
      </div>
    </eepos-header>
    <router-view />
  </div>
</template>

<script>
import { authContext } from "./auth";

export default {
  name: "app",
  data() {
    return {
      user: authContext.authenticated() && authContext.user.profile,
      token: null
    };
  },
  async created() {
    if (authContext.authenticated()) {
      this.$i18n.locale = authContext.user.profile.locale;
    }
    this.token = authContext.user.token;
  },
  methods: {
    logout() {
      authContext.logout();
    },
    userName() {
      return authContext.user.name;
    }
  },
  computed: {
    isTestingSystem() {
      return process.env.VUE_APP_IS_TEST_SYSTEM == "true";
    },
  }
};
</script>
